/*
  See https://develop.sentry.dev/sdk/data-model/envelopes/ for more details on the envelope format.
 */
const createEnvelopeHeader = ({ eventId }) => {
    return { event_id: eventId };
};
const createItemHeader = (type) => {
    return {
        type,
    };
};
const serializeEnvelope = (envelopeHeader, itemHeader, sentryError) => {
    const headerStr = JSON.stringify(envelopeHeader);
    const itemHeaderStr = JSON.stringify(itemHeader);
    const eventPayload = JSON.stringify(sentryError);
    return `${headerStr}\n${itemHeaderStr}\n${eventPayload}`;
};
export const createEnvelope = ({ sentryError }) => {
    const envelopeHeader = createEnvelopeHeader({ eventId: sentryError.event_id });
    const itemHeader = createItemHeader('event');
    return serializeEnvelope(envelopeHeader, itemHeader, sentryError);
};
